"use client";

import { useTranslations } from "next-intl";
import { SignupFlowSlug } from "@./state";
import type { IStep } from "../SimpleProgressSteps";

export const useSignupSteps = (): IStep[] => {
  const t = useTranslations("Forms.Fresh.SignUp.ProgressSteps");

  return [
    {
      label: t("myCats"),
      slugs: [
        SignupFlowSlug.CAT_COUNT,
        SignupFlowSlug.BASIC_INFORMATION,
        SignupFlowSlug.AGE,
        SignupFlowSlug.EATING_HABITS,
      ],
    },
    {
      label: t("health"),
      slugs: [
        SignupFlowSlug.FITNESS,
        SignupFlowSlug.WEIGHT,
        SignupFlowSlug.CURRENT_DIET,
        SignupFlowSlug.MEDICAL_CONDITIONS,
        SignupFlowSlug.ALLERGIES,
        SignupFlowSlug.MOTIVATION,
      ],
    },
    {
      label: t("myPlan"),
      slugs: [
        SignupFlowSlug.CAT_PARENT_DETAILS,
        SignupFlowSlug.RECIPES,
        SignupFlowSlug.WHY_FRESH,
      ],
    },
    {
      label: t("checkout"),
      slugs: [
        SignupFlowSlug.PRICING,
        SignupFlowSlug.TREATS,
        SignupFlowSlug.CHECKOUT,
      ],
    },
  ];
};
